import React, { useState } from 'react';
import Symbiosis from './Symbiosis';
import Nitro from './Nitro';
import './Ex.css';

const Ex = ({ block, coin }) => {
    const [showModal, setShowModal] = useState(false);
    const [selectedNetwork, setSelectedNetwork] = useState('');
    const [selectedStablecoin, setSelectedStablecoin] = useState('');
    const [isNetworkOpen, setIsNetworkOpen] = useState(false);
    const [isStablecoinOpen, setIsStablecoinOpen] = useState(false);

    const networks = [
        {
            id: 'solana',
            name: 'solana',
            stablecoins: ['USDC', 'USDT']
        },
        {
            id: 'polygon',
            name: 'polygon',
            stablecoins: ['USDT', 'USDC']
        },
        {
            id: 'base',
            name: 'base',
            stablecoins: ['USDC']
        },
        {
            id: 'arbitrum',
            name: 'arbitrum',
            stablecoins: ['USDT', 'USDC']
        },
        {
            id: 'optimism',
            name: 'optimism',
            stablecoins: ['USDT', 'USDC']
        },
        {
            id: 'Telegram Wallet (TON)',
            name: 'telegram',
            stablecoins: ['USDT']
        }
    ];

    const handleNetworkSelect = (network) => {
        setSelectedNetwork(network);
        setSelectedStablecoin('');
        setIsNetworkOpen(false);
    };

    const handleStablecoinSelect = (stablecoin) => {
        setSelectedStablecoin(stablecoin);
        setIsStablecoinOpen(false);
    };

    return (
        <>
            <div className="containers">
                <button
                    className="select-button"
                    onClick={() => setIsNetworkOpen(!isNetworkOpen)}
                >
                    {selectedNetwork ? networks.find(n => n.id === selectedNetwork).name : 'Select Network'}
                </button>

                {isNetworkOpen && (
                    <div className="dropdown">
                        {networks.map((network) => (
                            <button
                                key={network.id}
                                className="dropdown-item"
                                onClick={() => handleNetworkSelect(network.id)}
                            >
                                {network.name}
                            </button>
                        ))}
                    </div>
                )}

                {selectedNetwork && (
                    <div>
                        <button
                            className="select-button"
                            onClick={() => setIsStablecoinOpen(!isStablecoinOpen)}
                        >
                            {selectedStablecoin || 'Select Stablecoin'}
                        </button>

                        {isStablecoinOpen && (
                            <div className="dropdown">
                                {networks
                                    .find(n => n.id === selectedNetwork)
                                    .stablecoins.map((stablecoin) => (
                                        <button
                                            key={stablecoin}
                                            className="dropdown-item"
                                            onClick={() => handleStablecoinSelect(stablecoin)}
                                        >
                                            {stablecoin}
                                        </button>
                                    ))}
                            </div>
                        )}
                    </div>
                )}

                {selectedNetwork && selectedStablecoin && (
                    <button onClick={() => setShowModal(true)} className="action-button">
                        Connect Wallet
                    </button>
                )}
            </div>
            {showModal && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                <button onClick={() => setShowModal(false)} className="text-gray-600 hover:text-gray-800 fixed top-4 right-4 z-50">
                    ✖
                </button>
                {selectedNetwork !== "Telegram Wallet (TON)" && <Nitro borrow={{ name: selectedNetwork, coin: selectedStablecoin }} lend={{ name: block, coin: coin }} />}
                {selectedNetwork === "Telegram Wallet (TON)" && <Symbiosis data={{ name: block, coin: coin }} />}
            </div>}
        </>
    );
};

export default Ex;
